module.exports = __webpack_public_path__ + "assets/arrow_back.68421262.svg";